























































































































































import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISelectItem } from "@/types";
import {
  IUser,
  IUserCreateRequest,
  ISubcontractorCreateRequest
} from "@/types/user";
import { ISiteListRequest } from "@/types/site";
@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("user/adminGet")
  public getUser!: (user_id: number) => void;

  @Action("user/adminCreateSubcontractor")
  public create!: (params: IUserCreateRequest) => boolean;

  @Action("user/adminUpdateSubcontractor")
  public update!: (data: {
    user_id: number;
    params: IUserCreateRequest;
  }) => boolean;

  @Action("user/adminDelete")
  public delete!: (user_id: number) => boolean;

  @Action("user/isUniqueId")
  public isUniqueId!: (login_id: string) => boolean;

  @Action("site/adminGetList")
  public getSiteList!: (params: ISiteListRequest) => boolean;

  @Getter("user/single")
  public user!: IUser;

  @Getter("user/isUser")
  public isUser!: boolean;

  @Getter("site/selectItem")
  public sites!: ISelectItem[];

  @Mutation("user/clear")
  public clear!: () => void;

  public valid = true;
  public lazy = false;
  public dialog = false;
  public disp_password = false;
  public show_password_conf = false;
  public user_id = 0;
  public site_id = 0;

  public subcontractorDialog = false;
  public passwordValidation: Array<boolean | string> = [false];
  public confValidation: Array<boolean | string> = [true];
  public loginIdValidation: Array<boolean | string> = [false];

  public rules = {
    name: [
      (v: string) => !!v || "下請け名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "下請け名は30文字以下で入力してください"
    ],
    kana: [
      (v: string) => !!v || "フリガナは必須です",
      (v: string) =>
        (v && v.length <= 60) || "フリガナは60文字以下で入力してください",
      (v: string) =>
        /^[\u30A1-\u30FC]+$/.test(v) ||
        "フリガナは全角カタカナで入力してください"
    ],
    site_id: [(v: string) => !!v || "現場は必須です"],
    email: [
      (v: string) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "メールアドレスの形式が正しくありません"
    ]
  };

  public params: ISubcontractorCreateRequest = {
    name: "",
    kana: "",
    email: "",
    password: "",
    password_confirmation: "",
    login_id: "",
    site_id: 0,
    role: 20
  };

  public async created() {
    this.user_id = Number(this.$route.params.user_id);
    // this.site_id = this.params.site_id = Number(this.$route.params.site_id);
    this.clear();
    this.getSiteList({ per_page: 0 });
    // 更新
    if (this.user_id) {
      await this.getUser(this.user_id);
      this.loginIdValidation = [true];
    }
    this.setDefault();
  }

  private setDefault() {
    this.params.name = this.user.name || "";
    this.params.kana = this.user.kana || "";
    this.params.email = this.user.email || "";
    this.params.login_id = this.user.login_id || "";
    this.params.site_id = this.user.site_id;
    this.params.password = "";
    this.params.password_confirmation = "";
    this.params.role = this.user.role || 20;
  }

  public async submit() {
    let result = false;
    if (this.user.id) {
      result = await this.update({
        user_id: this.user.id,
        params: this.params
      });
      this.$router.go(-1);
      return;
    } else {
      result = await this.create(this.params);
    }
    if (result) {
      this.subcontractorDialog = true;
    }
  }
  public subcontractorDialogBtn() {
    this.subcontractorDialog = false;
    this.$router.push(`/admin/setting/subcontractor/list`);
  }

  /*
   ** パスワードバリデーション
   */
  public password_validate() {
    this.passwordValidation = [true];
    this.confValidation = [true];
    if (!this.params.password) {
      this.passwordValidation = ["パスワードは必須です"];
      return;
    }

    if (this.params.password.length <= 7) {
      this.passwordValidation = [
        "パスワードは半角英数8文字以上で設定してください"
      ];
      return;
    }

    if (this.params.password !== this.params.password_confirmation) {
      this.confValidation = ["パスワードが一致していません"];
      return;
    }
  }

  /*
   ** ログインIDバリデーション
   */
  public async login_id_validate() {
    //
    if (this.user_id && this.user.login_id === this.params.login_id) {
      this.loginIdValidation = [true];
      return;
    }

    this.loginIdValidation = ["検証中"];
    if (!this.params.login_id) {
      this.loginIdValidation = ["ログインIDは必須です"];
      return;
    }
    if (!(await this.isUniqueId(this.params.login_id))) {
      this.loginIdValidation = ["既に利用されているIDです"];
      return;
    }
    this.loginIdValidation = [true];
  }

  //--------
  // 削除確認画面
  public destroyConfirm() {
    this.dialog = true;
  }

  //--------
  // 削除実行
  public async destroy() {
    this.dialog = false;
    if (await this.delete(this.user_id)) {
      this.$router.go(-1);
    }
  }
}
